import { inWechat, isWeCom, isMiniBankInsurance } from 'base/config'
import { getUrlParam, getUrlByAddingParam, getUrlByDeletingParam, getToken } from 'common/js/common'
import { getApplicationInfo, pbCompareShare } from 'api/index'
import Wechat from 'base/wechat'
import { isApp } from '@/common/utils/variables'

const TIMESTAMP_KEY = 'wechat_oauth_token_timestamp' //'WeiyiStat_pbfm_token_timestamp'
const TOKEN_KEY = 'wechat_oauth_token_openid' // 'WeiyiStat_pbfm_token_openid'
const SHARE_ACTION = ['wechat_friends', 'wechat_timeline']
const SHARE_TITLE = '家庭保障计划'
const SHARE_CONTENT = '请查收您的专属家庭保障计划，保险让生活更美好'
const SHARE_IMGURL =
  'https://img.winbaoxian.com/autoUpload/planbook/bdzl_17f6c79a95c37c3.jpeg'

export default {
  methods: {
    async initActionSheet(config) {
      if (!isApp && !isWeCom && !isMiniBankInsurance) return
      const { _cardUuid } = this
      const href = location.href
      const uuid = getUrlParam('uuid', href)
      const isPbCompareShare = /planbkContrastCollection/.test(href)
      const shareUrl = getUrlByAddingParam({ cardUuid: _cardUuid }, href)

      const shareGroup = (this._shareGroup = SHARE_ACTION.map(item => {
        const newShare = {
          action: item,
          title: config.title || SHARE_TITLE,
          content: config.content || SHARE_CONTENT,
          shareUrl: config.shareUrl || shareUrl,
          imgUrl: config.imgURL || SHARE_IMGURL
        }
        newShare.lazyDataCb = async () => {
          const _share = Object.assign({}, newShare)
          if (['wechat_friends', 'wechat_timeline'].indexOf(item) >= 0) {
            const appParams = await this.getAppParams()
            _share.shareUrl = getUrlByAddingParam(
              appParams,
              _share.shareUrl,
              true
            )
          }
          // 对比，统计
          if (isPbCompareShare) {
            pbCompareShare({ uuid })
          }
          return _share
        }
        return newShare
      }))
      // wxwork
      if (isWeCom && window.WeCom && WeCom.initWeComConfig) {
        const appParams = await this.getAppParams()
        const newShare = {
          title: config.title || SHARE_TITLE,
          desc: config.content || SHARE_CONTENT,
          imgUrl: config.imgURL || SHARE_IMGURL,
          link: getUrlByAddingParam({ cardUuid: _cardUuid }, config.shareUrl || shareUrl)
        }
        newShare.link = getUrlByAddingParam(
          appParams,
          newShare.link,
          true
        )
        // 企微统计
        if (isPbCompareShare) {
          newShare.success = () => {
            pbCompareShare({ uuid })
          }
        }
        WeCom.initWeComConfig(newShare)
        return
      }
      // 银保小程序
      if (isMiniBankInsurance && WeCom.initMiniConfig) {
        const newShare = {
          title: config.title || SHARE_TITLE,
          desc: config.content || SHARE_CONTENT,
          imgUrl: config.imgURL || SHARE_IMGURL,
          link: getUrlByAddingParam({ cardUuid: _cardUuid }, config.shareUrl || shareUrl)
        }
        WeCom.initMiniConfig(newShare)
        return
      }

      if (
        window.appBridge &&
        appBridge.checkAppFeature('COMMON_ACTION_SHEET')
      ) {
        appBridge.commonActionSheet({
          shareGroup
        })
      }
    },
    async getAppParams() {
      let appParams = {}
      if (this.appParams && this.appParams.wxMpAppid) {
        return Promise.resolve(this.appParams)
      }
      try {
        const {
          data: { success, data }
        } = await getApplicationInfo()
        if (success && data) {
          if (data.wxMpAppid) {
            appParams.wxMpAppid = data.wxMpAppid
          }
          if (data.thirdPlatformAppid) {
            appParams.component_appid = data.thirdPlatformAppid
          }
          this.appParams = appParams
        }
      } catch (e) {
        appParams.wxMpAppid = BC.wxMpAppid
      }
      return Promise.resolve(appParams)
    },
    initWechatShare(config) {
      const shareUrl = getUrlByDeletingParam(
        {
          autoOauth: false,
          token: false,
          fromWyjhs: false
        },
        config.shareUrl || location.href
      );
      const configParams = {
        title: config.title || SHARE_TITLE,
        link: shareUrl,
        desc: config.content || SHARE_CONTENT,
        imgUrl: config.imgURL || SHARE_IMGURL
      }
      if (inWechat && !isWeCom && !isMiniBankInsurance) {
        const wxMpAppid = getUrlParam('wxMpAppid', shareUrl)
        Wechat(
          configParams,
          location.href,
          wxMpAppid
        )
      }
    },
    initSocial(config = {}) {
      this.initActionSheet(config)
      this.initWechatShare(config)
    },
    getToken() {
      return getToken(TOKEN_KEY, TIMESTAMP_KEY)
    },
    getOperate(source, options) {
      const { _token, _cardUuid } = this
      if (!_cardUuid) return

      return {
        operate: 'view',
        cardUuid: _cardUuid,
        token: _token,
        source,
        ...options
      }
    }
  }
}
